import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Button,
  Table,
  Form,
  Label,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import { useHistory } from "react-router-dom"
import ReactPaginate from "react-paginate"
import { URLS } from "../../Url"
import axios from "axios"
import { CSVLink } from "react-csv"
import jsPDF from "jspdf"
import "jspdf-autotable"

function Ventures() {
  const [Actin, setActin] = useState([])
  const [communities, setCommunities] = useState([])
  const [categories, setcategories] = useState([])
  const [filter, setFilter] = useState(false)
  const [filters, setFilters] = useState({ community: "", categoryName:"" })
  const [Searchs, setSearchs] = useState({})
  const [listPerPage] = useState(5)
  const [pageNumber, setPageNumber] = useState(0)

  const history = useHistory()
  const token = JSON.parse(localStorage.getItem("authUser"))?.token

  useEffect(() => {
    GetUsers()
    datass()
    fetchCommunities()
    GetAllCategories()
  }, [])

  const GetUsers = () => {
    axios
      .post(
        URLS.GetPendingVendor,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(res => {
        setActin(res.data.user)
        setPageNumber(0)
      })
      .catch(err => console.error(err))
  }

  const fetchCommunities = () => {
    axios
      .post(
        "https://api.jaininternationalnetwork.com/v1/a2zsolutionsapi/admin/community/getall",
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(res => {
        if (res.data.success) {
          const userCommunityObjects = res.data.usercommunities.map(
            (community, index) => ({
              _id: `user_${index}`,
              community: community,
            })
          )

          // comibing the communities and usercommunities
          const allCommunities = [
            ...(res.data.communities || []),
            ...userCommunityObjects,
          ]

          setCommunities(allCommunities)
        } else {
          toast(res.data.message)
        }
      })
  }

    // categories
    const GetAllCategories = () => {
      axios
        .post(
          "https://api.jaininternationalnetwork.com/v1/a2zsolutionsapi/admin/category/getallcategorys",
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        )
        .then(res => {
          if (res.data.success) {
            setcategories(res.data.category)
          } else {
            toast(res.data.message)
          }
        })
    }
  // setCommunities
  const pagesVisited = pageNumber * listPerPage
  const lists = Actin.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(Actin.length / listPerPage)

  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  const Actinid1 = data => {
    sessionStorage.setItem("VendorId", data._id)
    history.push("/ViewPendingVendor")
  }

  const datass = () => {
    const location = sessionStorage.getItem("tost")
    if (location) {
      toast(location)
      sessionStorage.clear()
    } else {
      sessionStorage.clear()
    }
  }

  const Search = e => {
    let myUser = { ...Searchs }
    myUser[e.target.name] = e.target.value
    setSearchs(myUser)

    axios
      .post(
        `${URLS.GetPendingSearchVendor}${e.target.value}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(res => {
        setActin(res.data.user)
      })
      .catch(err => console.error(err))
  }

  const handleChangeflt = e => {
    let myUser = { ...filters }
    myUser[e.target.name] = e.target.value
    setFilters(myUser)
  }

  const getfilter = e => {
    e.preventDefault()
    GetOrderFiliter()
  }

  const GetOrderFiliter = () => {
    // const data = { community: filters.community }
    const bodyData = {
      community: filters.community,
      categoryName: filters.categoryName,
    };
  
    axios
      .post(URLS.GetPendingVendor, bodyData, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(res => {
        setActin(res.data.user)
        hidefilter()
        setFilters({ community: "", categoryName:""})
      })
      .catch(err => console.error(err))
  }

  const handleReset = () => {
    setSearchs({ name: "", email: "", phone: "" })
    setFilters({ community: "", categoryName: ""})
    setPageNumber(0)
    GetUsers()
  }

  const hidefilter = () => setFilter(false)

  // excel funtionality
  const headers2 = [
    { label: "S.No", key: "sno" },
    { label: "Name", key: "name" },
    { label: "phone", key: "phone" },
    { label: "Email", key: "email" },
    { label: "Community", key: "community" },
    { label: "Vendor Status", key: "vendorStatus" },
  ]

  const csvData = Actin.map((elt, i) => ({
    sno: i + 1,
    name: elt.name,
    phone: elt.phone,
    email: elt.email,
    community: elt.community,
    vendorStatus: elt.vendorStatus,
  }))

  const csvReport = {
    filename: "PendingBusinessMan.csv",
    headers: headers2,
    data: csvData,
  }

  const exportPDF = () => {
    const unit = "pt"
    const size = "A2"
    const orientation = "portrait"
    const doc = new jsPDF(orientation, unit, size)
    doc.setFontSize(15)
    const headers123 = [
      [
        "S.No",
        "Name",
        "Phone",
        "Email",
        "Community",
        "Status",
      ],
    ]

    const data123 = Actin.map((elt, i) => [
      i + 1,
      elt.name,
      elt.phone,
      elt.email,
      elt.community,
      elt.vendorStatus,
    ])

    let content = {
      startY: 50,
      head: headers123,
      body: data123,
    }
    console.log(content)
    doc.autoTable(content)
    doc.save("Pending_Business_Man.pdf")
  }

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var Roles = data?.rolesAndPermission[0]

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title="Home"
            breadcrumbItem="Pending Business Man"
          />
          {filter && (
            <Card>
              <CardBody>
                <Form onSubmit={getfilter}>
                  <Row>
                    <Col lg="3">
                      <div className="mb-3">
                        <Label for="community-filter">
                          Community 
                        </Label>
                        <select
                          id="community-filter"
                          className="form-select"
                          value={filters.community}
                          name="community"
                          onChange={handleChangeflt}
                        >
                          <option value="">Select</option>
                          {communities.map((community, index) => (
                            <option key={index} value={community.community}>
                              {community.community}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Col>
                    <Col lg="3">
                      <div className="mb-3">
                        <Label for="category-filter">
                          Category  
                        </Label>
                        <select
                          id="category-filter"
                          className="form-select"
                          value={filters.categoryName}
                          name="categoryName"
                          onChange={handleChangeflt}
                        >
                          <option value="">Select</option>
                          {categories.map((category, index) => (
                            <option key={index} value={category.name}>
                              {category.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Col>
                    <Col lg="3">
                      <div className="mt-4">
                        <Button type="submit" className="m-1" color="info">
                          <i className="fas fa-check-circle"></i> Search
                        </Button>
                        <Button
                          onClick={hidefilter}
                          className="m-1"
                          color="danger"
                        >
                          <i className="fas fa-times-circle"></i> Cancel
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          )}
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Row>
                    <Col>
                      <Button
                        className="m-1"
                        onClick={() => setFilter(!filter)}
                        color="info"
                      >
                        <i className="fas fa-filter"></i> Filter
                      </Button>
                      <Button
                        className="m-1"
                        onClick={handleReset}
                        color="info"
                      >
                        <i className="fas fa-sync-alt"></i> Reset
                      </Button>
                      <CSVLink {...csvReport}>
                        <button
                          className="btn btn-success me-2 m-1"
                          type="button"
                        >
                          <i className="fas fa-file-excel"></i> Excel
                        </button>
                      </CSVLink>
                      <Button
                        type="button"
                        className="btn btn-danger "
                        onClick={exportPDF}
                      >
                        <i className="fas fa-file-pdf"></i> Pdf
                      </Button>
                    </Col>
                    <Col>
                      <div style={{ float: "right" }}>
                        <Input
                          type="search"
                          name="search"
                          value={Searchs.search || ""}
                          onChange={Search}
                          className="form-control"
                          placeholder="Search.."
                          autoComplete="off"
                        />
                      </div>
                    </Col>
                  </Row>
                  <div className="table-rep-plugin mt-4 table-responsive">
                    <Table hover className="table table-bordered mb-4">
                      <thead>
                        <tr className="text-center">
                          <th>SlNo</th>
                          <th>Name</th>
                          <th>Phone</th>
                          <th>Email</th>
                          <th>Community</th>
                          <th>Business Type</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lists.map((data, key) => (
                          <tr key={data._id} className="text-center">
                            <td>{pageNumber * listPerPage + key + 1}</td>
                            <td>{data.name}</td>
                            <td>{data.phone}</td>
                            <td>{data.email}</td>
                            <td>{data.community}</td>
                            <td>{data.vendor ? "Vendor" : "Business"}</td>
                            <td>
                              <span className="badge bg-warning">
                                {data.vendorStatus}
                              </span>
                            </td>
                            <td>
                              <Button
                                onClick={() => Actinid1(data)}
                                className="m-1 btn-sm"
                                color="info"
                              >
                                <div className="d-flex">
                                  <small>
                                    <i className="fas fa-eye m-1"></i> View
                                  </small>
                                </div>
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <div
                      className="d-flex mt-3 mb-1"
                      style={{ float: "right" }}
                    >
                      <ReactPaginate
                        previousLabel={"Previous"}
                        nextLabel={"Next"}
                        pageCount={pageCount}
                        onPageChange={changePage}
                        containerClassName={"pagination"}
                        previousLinkClassName={"previousBttn"}
                        nextLinkClassName={"nextBttn"}
                        disabledClassName={"disabled"}
                        activeClassName={"active"}
                        forcePage={pageNumber}
                      />
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ToastContainer />
        </div>
      </div>
    </React.Fragment>
  )
}

export default Ventures
